// 判断都是微信浏览器环境
function environmentBrowser() {
  let weixinShareBtn = null;
  var ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    weixinShareBtn = true;
  } else {
    weixinShareBtn = false;
  }
  return weixinShareBtn;
};

// js获取url
function getUrlKey(name, url) {
  if (url.indexOf("?") == -1) return '';
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(url) || [, ""])[1].replace(/\+/g, '%20')) || ''
};

// 字符串截取出openid函数封装
function splitOpenid(url) {
  if (url.indexOf('openid=') == -1) return '';

  let arr1 = url.split('?');
  let str = arr1[1];
  let arr2 = str.split('=');
  let str1 = arr2[1];
  return str1;

};

// 获取进入时的路由
function getIntoUrl(url) {
  let str = '';
  let arr1 = url.split('/');
  str = arr1[arr1.length - 1];
  if (str.indexOf("?") != -1) {
    let arr2 = str.split('?')
    str = arr2[0];
  }
  return str;
};

export {
  environmentBrowser,
  getUrlKey,
  splitOpenid,
  getIntoUrl,
}
